import { IRoute } from './../Entities/entities';
/* tslint:disable:max-line-length */
export enum PipeEnum {
  decimalPipe,
  datePipe,
  UFPipe,
  currencyCLPipe,
  checkNumberPipe,
  percentagePipe,
  purePercentagePipe,
  dateNombreMesPipe,
  dateNombreMesPipe2,
  edadPipe,
  thousandPipe,
}

export enum statusEnum {
  error,
  success,
}

export const productosPath = {
  path: 'productos',
  children: {
    colectivo: {
      path: 'colectivo',
      rootPath: 'productos',
      label: 'Seguro Colectivo',
      children: {
        resumen: {
          path: 'resumen',
        } as IRoute,
        detalle: {
          path: 'detalleSeguro/:id',
        } as IRoute,
      },
    } as IRoute,
    individual: {
      path: 'individual',
      rootPath: 'productos',
      label: 'Seguro Individual',
      children: {
        resumen: {
          path: 'resumen',
        } as IRoute,
        detalle: {
          path: 'detalleSeguro/:id',
        } as IRoute,
      },
    } as IRoute,
    vitalicio: {
      path: 'vitalicio',
      rootPath: 'productos',
      label: 'Renta Vitalicia',
      children: {
        resumen: {
          path: 'resumen',
        } as IRoute,
        detalle: {
          path: 'detalleSeguro/:id',
        } as IRoute,
      },
    } as IRoute,
    privado: {
      path: 'privado',
      rootPath: 'productos',
      label: 'Renta Privadas',
      children: {
        resumen: {
          path: 'resumen',
        } as IRoute,
        detalle: {
          path: 'detalleSeguro/:id',
        } as IRoute,
      },
    } as IRoute,
    salud: {
      path: 'salud',
      rootPath: 'productos',
      label: 'Salud Individual',
      children: {
        resumen: {
          path: 'resumen',
        } as IRoute,
        detalle: {
          path: 'detalleSeguro/:id',
        } as IRoute,
      },
    } as IRoute,
  },
} as IRoute;

export const paths = {
  root: {
    path: '',
  } as IRoute,
  login: {
    path: 'loginInt',
  } as IRoute,
  identify: {
    path: 'auth',
  } as IRoute,
  recuperarClave: {
    path: 'recuperarClave',
  } as IRoute,
  cerrarSesion: {
    path: 'cerrarSesion',
  } as IRoute,
  print: {
    path: 'print/:key',
  } as IRoute,
  firmaElectronica: {
    path: 'firmaElectronica/:id',
    label: 'Firma Electrónica',
  } as IRoute,
  claveTemporal: {
    path: 'claveTemporal',
    label: 'Modificar mis datos',
  } as IRoute,
  misDatos: {
    path: 'misDatos/:idpoliza',
    label: 'Mis Datos',
  } as IRoute,
  misDatosEmpty: {
    path: 'misDatos',
    label: 'Mis Datos',
  } as IRoute,
  cambiarContrasena: {
    path: 'cambiarContrasena',
    label: 'Cambiar Contraseña',
  } as IRoute,
  pagarProductos: {
    path: 'pagarProductos',
    label: 'Pagar Mis Productos',
  } as IRoute,
  informeRentabilidad: {
    path: 'informeRentabilidad',
    label: 'Informe De Rentabilidad',
  } as IRoute,
  loginSso: {
    path: 'loginSso',
    label: 'login sso',
  } as IRoute,
  comprobanteToku: {
    path: 'comprobanteToku',
    label: 'Comprobante Toku',
  } as IRoute,
};

export const individualRegimenTributariosText =
  'Régimen Tributario Letra B Art. 20 del D. L. 3500:\n' +
  'Los Depósitos de APV acogidos a este régimen rebajan la base tributable del contratante con un tope de 50 UF al mes (tope válido para Depositos de APV y Cotizaciones Voluntarias en conjunto). Si el ahorro es efectuado de manera directa por el trabajador, se debe reliquidar el impuesto único de segunda categoría, rebajando estos aportes de APV de la base imponible de Global Complementario, con un tope de 600 UF. Los retiros de todo o parte de los recursos originados en depósitos de APV y/o cotizaciones voluntarias, que no se destinen a incrementar o anticipar la pensión, están afectos a Global Complementario más una sobre tasa entre 3% y 7%. No obstante lo anterior, la Compañía deberá efectuar una retención del 15% a dichos retiros, lo que servirá de abono al impuesto único a que están afectos.';

export const vitaliciaBeneficiosText =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n\n' +
  'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.\n\n' +
  'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.\n\n' +
  'Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur.\n\n' +
  'Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur.\n\n' +
  'Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam.\n\n' +
  'Los Depósitos de APV acogidos a este régimen no tienen beneficio tributario al momento de efectuar el ahorro, es decir, los aportes no rebajan la base tributable del trabajador, sin embargo, al efectuar retiros que no se destinen a incrementar o anticipar la pensión, sólo se paga impuesto por la rentabilidad asociada al monto retirado. Además con esta modalidad el trabajador accede a una bonificación estatal, correspondiente al 15% del monto que ahorre y con un tope de 6 UTM por año calendario, siempre que este ahorro sea destinado a pensión.';

export const individualSaldoPorCuentaText =
  'Regímenes Tributarios vigentes desde Octubre de 2008 para el ahorro Previsional Voluntario (APV).\n\n' +
  'Régimen Tributario Letra A Art. 20 del D.L. 3500:\n' +
  'Los Depósitos de APV acogidos a este régimen no tienen beneficio tributario al momento de efectuar el ahorro, es decir, los aportes no rebajan la base tributable del trabajador, sin embargo, al efectuar retiros que no se destinen a incrementar o anticipar la pensión, sólo se paga impuesto por la rentabilidad asociada al monto retirado. Además con esta modalidad el trabajador accede a una bonificación estatal, correspondiente al 15% del monto que ahorre y con un tope de 6 UTM por año calendario, siempre que este ahorro sea destinado a pensión.' +
  '\n\n' +
  'Régimen Tributario Letra B Art. 20 del D. L. 3500:\n' +
  'Los Depósitos de APV acogidos a este régimen rebajan la base tributable del contratante con un tope de 50 UF al mes (tope válido para Depositos de APV y Cotizaciones Voluntarias en conjunto). Si el ahorro es efectuado de manera directa por el trabajador, se debe reliquidar el impuesto único de segunda categoría, rebajando estos aportes de APV de la base imponible de Global Complementario, con un tope de 600 UF. Los retiros de todo o parte de los recursos originados en depósitos de APV y/o cotizaciones voluntarias, que no se destinen a incrementar o anticipar la pensión, están afectos a Global Complementario más una sobre tasa entre 3% y 7%. No obstante lo anterior, la Compañía deberá efectuar una retención del 15% a dichos retiros, lo que servirá de abono al impuesto único a que están afectos.';

export const saldoCuentaGroup = {
  title: 'RÉGIMENES TRIBUTARIOS VIGENTES',
  items: [
    {
      title: 'Régimen Tributario Letra A Art. 20 del D.L. 3500:',
      regimen: 'A',
      content:
        'Los depósitos de APV acogidos a este régimen, no tienen beneficio tributario al momento de efectuar el ahorro, es decir los aportes no rebajan la base tributable del trabajador, sin embargo al efectuar retiros que no se destinen a incrementar o anticipar la pensión, sólo se paga impuesto por la rentabilidad asociada al monto retirado. Además con esta modalidad el trabajador accede a una bonificación estatal, correspondiente al 15% del monto que ahorre y con un tope de 6UTM por año calendario, siempre que este ahorro sea destinado a pensión.',
    },
    {
      title: 'Régimen Tributario Letra B Art. 20 del D. L. 3500:',
      regimen: 'B',
      content:
        'Los depósitos de APV acogidos a este régimen rebajan la base tributable del contratante con un tope de 50UF al mes (tope válido para depósitos en APV y Cotizaciones Voluntarias en conjunto. si el ahorro es efectuado de manera directa por el trabajador se debe re liquidar el impuesto único de segunda categoría, rebajando estos aportes de APV de la base imponible de Global Complementario con un tope de 600UF. Los retiros de todo o parte de los recursos otorgados en depósitos de APV y/o cotizaciones voluntarias que no se destinen a incrementar o anticipar la pensión están afectados a Global Complementario más una sobre tasa entre 3% y 7%. No obstante lo anterior la Compañía deberá efectuar una retención del 15% a dichos retiros, lo que servirá de abono al impuesto único a que estén afectos.',
    },
  ],
};

export const AdministracionAhorros = ['ahorro', '57 bis', 'apv'];

export const LifeMax = '9840';

export enum DeudaEnum {
  sinDeuda,
  unaCuota,
  dosCuota,
  tresCuota,
  unaCuotaTradicional,
}

export const paginatorConfig = {
  paginatorLength: 0,
  pageSize: 5,
  pageSizeOptions: [5, 10, 25, 100],
};

export const tipoPrima = {
  periodica: 'PERIÓDICA',
  esporadica: 'ESPORÁDICA',
};

export const tipoPago = {
  periodica: 'PRI',
  esporadica: 'ESP',
};

export const FORMA_PAGO = {
  servipag: 'servipag',
  webpay: 'webpay',
  toku: 'toku',
};

export const screenSizes: Map<string, string> = new Map([
  ['xl', '(min-width: 1200px)'],
  ['lg', '(min-width: 992px)'],
  ['md', '(min-width: 768px)'],
  ['sm', '(min-width: 576px)'],
  ['xs', '(min-width: 0px)'],
]);

export const menuWidth = 860;

export const key_user_info = 'userInfo';
export const key_local_linea_nego = 'lineasNegocio';
export const RutEmpresa = 'RE';
export const TipoPago = 'AYP';

// --------------------------------------------
// Producto Seguro Salud Individual
// --------------------------------------------
export const SALUD_IND_USE_DUMMY = false;
export const SALUD_INDIVIDUAL = [7320, 7321, 7325];
export const SALUD_IND_PRESTACIONES = ['7325'];

export const LINEA_NEGOCIO = {
  SALUD_INDIVIDUAL: 'SEGURO SALUD',
};

export const SALUD_INDIVIDUAL_EJECUTIVA = {
  Rut: '',
  DV: '',
  Nombres: 'Ejecutiva',
  Apellidos: 'Salud Individual',
  Mail: 'contactovida@security.cl',
  Telefono: '',
  idPoliza: null,
};
